angular.module('unergie.main')
.filter('organizationType', (FilterMapping) =>
    function (val) {
        return (_.find(FilterMapping.organizationTypes, { id: val }) || { title: val }).title
    }
)
